import React from 'react';

import FormGroupWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/FormGroupWrapper';
import CustomDropdown from '@/components/CustomDropdown';
import InputField from '@/components/InputField';
import InputWrapper from '@/features/sampleDevelopment/components/SampleRequestModals/InputWrapper';
import {
	formatBrandOptions,
	formatProjectDealOptions,
	formatSampleTypeOptions
} from '@/features/sampleDevelopment/utils';
// import { REQUEST_FOR_SAMPLE_SECTION } from '@/features/sampleDevelopment/constants';

const SendToSampleSectionForm = ({
	handleChange,
	requestValues,
	errors,
	sampleTypeList = [],
	isReviseSample,
	brands,
	projectDealList
}) => {
	const updatedSampleTypeList = sampleTypeList?.filter((item) => item?.constant !== 'REVISE');
	return (
		<React.Fragment>
			<div className="flied-item d-grid grid-columns-2 gap-3">
				<InputWrapper labelTitle="Required date*">
					<InputField
						type="date"
						name="requiredDate"
						value={requestValues?.requiredDate}
						onChangeHandler={(e) => handleChange('requiredDate', e.target.value)}
						withWrapper={false}
						withLabel={false}
						errors={errors?.requiredDate}
					/>
				</InputWrapper>
				{/* <FormGroupWrapper labelTitle="Request for*">
					<CustomDropdown
						title="Select request for"
						onItemClick={(value) => handleChange('requestFor', value)}
						selectedItem={requestValues?.requestFor?.value}
						items={REQUEST_FOR_SAMPLE_SECTION}
					/>
					{errors?.requestFor && <p className="error">{errors?.requestFor}</p>}
				</FormGroupWrapper> */}
				<FormGroupWrapper labelTitle="Sample Type">
					<CustomDropdown
						isDisabled={isReviseSample}
						title="Select sample type"
						onItemClick={(value) => handleChange('sampleType', value)}
						selectedItem={isReviseSample ? 'Revise' : requestValues?.sampleType?.value}
						items={formatSampleTypeOptions(updatedSampleTypeList)}
					/>
					{errors?.sampleType && <p className="error">{errors?.sampleType}</p>}
				</FormGroupWrapper>
			</div>
			<div className={`${isReviseSample ? 'flied-item d-grid grid-columns-2 gap-3 ' : 'd-none'}`}>
				<FormGroupWrapper labelTitle={`Customer Name*`}>
					<CustomDropdown
						title={`Select brand name`}
						onItemClick={(value) => handleChange('brand', value)}
						selectedItem={requestValues?.brand?.name}
						items={formatBrandOptions(brands)}
					/>
					{errors?.brand && <p className="error">{errors?.brand}</p>}
				</FormGroupWrapper>
				<FormGroupWrapper labelTitle="Deal">
					<div className={!requestValues?.brand?.id ? 'cursor-none' : ''}>
						<CustomDropdown
							title="Select"
							onItemClick={(value) => handleChange('projectDealName', value)}
							selectedItem={
								requestValues?.projectDealName?.dealName ||
								requestValues?.projectDealName?.value
							}
							items={formatProjectDealOptions(projectDealList)}
							toolTipLength={25}
						/>
					</div>
					{errors?.projectDealName && <p className="error">{errors?.projectDealName}</p>}
				</FormGroupWrapper>
			</div>
		</React.Fragment>
	);
};

export default SendToSampleSectionForm;
